import { Component, OnInit, Input } from '@angular/core';
import { DireccionesPersonal } from '../../../../models/direcciones-personal';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ProvinciaService } from '../../../../services/provincia.service';
import { ConfigDataService } from '../../../../services/config-data.service';
import {MyValidations} from '../../../../utils/my-validations';

@Component({
  selector: 'app-direccion-detalle',
  templateUrl: './direccion-detalle.component.html',
  styleUrls: ['./direccion-detalle.component.css']
})
export class DireccionDetalleComponent implements OnInit{

  constructor(private configDataSrv: ConfigDataService,
              private provinciaService: ProvinciaService, 
              private fb: FormBuilder) { }

  @Input() set direccion(direccionRecibida: DireccionesPersonal)
  {
    this.direccionForm = direccionRecibida;
    this.setearForm(direccionRecibida);
  }

  @Input() set enabledForm(condition: boolean)
  {
    this.habilitarForm(condition);
  }

  @Input() MensajeError: string;
  @Input() verDetalle: boolean;
  @Input() disabledEditing: boolean;
  @Input() desdeAnterior: boolean;
  @Input() ingreso: any;

  form: FormGroup;
  clasesDireccionList: any;
  paisesList: any;
  provinciasList: any;
  submitted: boolean;
  direccionForm: DireccionesPersonal;
  selectedPais: number;
  
  ngOnInit(): void
  {
    this.configDataSrv.getDatosDirecciones()
      .subscribe(
        data => {
          this.clasesDireccionList=data["ClaseDireccion"];
          this.paisesList=data["Paises"];
          this.provinciasList=data["Provincias"];
        },
        error => {
          console.log(error);
        });
    
    this.configurarValidadores();
    this.setearForm(this.direccionForm);
   
  }
       
  configurarValidadores(): void
  {
    this.form = this.fb.group({
      id: ['', Validators.required],
      desde: ['', Validators.required],
      hasta: ['', [Validators.required, MyValidations.fecHastaMenor]],
      personal: ['', Validators.required],
      clase: ['', Validators.required],
      calle: ['', Validators.required],
      nro: ['', Validators.required],
      piso: [''],
      dpto: [''],
      localidad: ['', Validators.required],
      codPos: ['', Validators.required],
      pais: ['', Validators.required],
      provincia: ['', Validators.required],
      telefono: ['', Validators.required],
      observaciones: ['']
    });
  }

  get registerFormControl()
  {
    return this.form.controls;
  }

  setearForm(direccion: DireccionesPersonal)
  {
    if (this.form != undefined)
    {
      this.form.controls['id'].setValue(direccion?.id);
      this.form.controls['desde'].setValue(new Date(direccion?.desde));
      this.form.controls['hasta'].setValue(new Date(direccion?.hasta));
      this.form.controls['calle'].setValue(direccion?.calle);
      this.form.controls['clase'].setValue(direccion?.clase);
      this.form.controls['codPos'].setValue(direccion?.codPos);
      this.form.controls['dpto'].setValue(direccion?.dpto);
      this.form.controls['localidad'].setValue(direccion?.localidad);
      this.form.controls['nro'].setValue(direccion?.nro);
      this.form.controls['observaciones'].setValue(direccion?.observaciones);
      this.form.controls['pais'].setValue(direccion?.pais);
      this.form.controls['piso'].setValue(direccion?.piso);
      this.form.controls['provincia'].setValue(direccion?.provincia);
      this.form.controls['telefono'].setValue(direccion?.telefono);
      this.form.controls['personal'].setValue(direccion?.personal);
      
      if (direccion.id == 0)
      {
        this.habilitarForm(true);
      }
      else
      {
        this.habilitarForm(false);
      }

      this.cargarprovincias(direccion.pais);      

    }
  }

  cargarprovincias(pais:number){
    if (pais != null) {
      this.provinciaService.getPais(pais).subscribe(provincias => { this.provinciasList = provincias })
    }
  }

  onChangePais(event) {
    this.form.controls['provincia'].setValue(null);
    this.cargarprovincias(event.value);    
  }

  habilitarForm(habilitado: boolean)
  {
    if (this.form != undefined)
    {
      if (habilitado)
      {
        this.form.enable();
      }
      else
      {
        this.form.disable();
      }
    }
  }


}
